import type { GuideStoryId } from './guideArticles'

export type GuideStorySubsection = {
  titleKey: string
  bulletKeys: string[]
  variant?: 'platform' | 'peer'
}

export type GuideStoryTip = {
  labelKey: string
  bodyKey: string
}

export type GuideStorySection = {
  titleKey?: string
  bodyKey?: string
  bulletKeys?: string[]
  tips?: GuideStoryTip[]
  subsections?: GuideStorySubsection[]
}

export type GuideStoryLayout = {
  leadKey: string
  hideCover?: boolean
  sections: GuideStorySection[]
}

/** Structured article body (e.g. VERIFY → No Rock philosophy). */
export const GUIDE_STORY_LAYOUTS: Partial<Record<GuideStoryId, GuideStoryLayout>> = {
  s1: {
    leadKey: 'vc.story.s1.p1',
    sections: [
      {
        titleKey: 'vc.story.s1.secGradesTitle',
        tips: [
          { labelKey: 'vc.story.s1.gradeExcellent', bodyKey: 'vc.story.s1.gradeExcellentDesc' },
          { labelKey: 'vc.story.s1.gradeGood', bodyKey: 'vc.story.s1.gradeGoodDesc' },
          { labelKey: 'vc.story.s1.gradeFair', bodyKey: 'vc.story.s1.gradeFairDesc' },
          { labelKey: 'vc.story.s1.gradeDamaged', bodyKey: 'vc.story.s1.gradeDamagedDesc' },
        ],
      },
      {
        bodyKey: 'vc.story.s1.closingNote',
      },
    ],
  },
  s2: {
    leadKey: 'vc.story.s2.p1',
    sections: [
      {
        titleKey: 'vc.story.s2.secTipsTitle',
        bulletKeys: ['vc.story.s2.p2', 'vc.story.s2.p3', 'vc.story.s2.p4', 'vc.story.s2.p5'],
      },
    ],
  },
  s3: {
    leadKey: 'vc.story.s3.p1',
    sections: [
      {
        titleKey: 'vc.story.s3.secTipsTitle',
        bulletKeys: ['vc.story.s3.p2', 'vc.story.s3.p3', 'vc.story.s3.p4', 'vc.story.s3.p5'],
      },
    ],
  },
  s4: {
    leadKey: 'vc.story.s4.p1',
    sections: [
      {
        titleKey: 'vc.story.s4.secTipsTitle',
        bulletKeys: ['vc.story.s4.p2', 'vc.story.s4.p3', 'vc.story.s4.p4', 'vc.story.s4.p5'],
      },
    ],
  },
  s5: {
    leadKey: 'vc.story.s5Lead',
    hideCover: true,
    sections: [
      {
        titleKey: 'vc.story.s5.sec1Title',
        subsections: [
          {
            titleKey: 'vc.story.s5.sec1PlatformTitle',
            variant: 'platform',
            bulletKeys: [
              'vc.story.s5.sec1PlatformB1',
              'vc.story.s5.sec1PlatformB2',
              'vc.story.s5.sec1PlatformB3',
            ],
          },
          {
            titleKey: 'vc.story.s5.sec1PeerTitle',
            variant: 'peer',
            bulletKeys: [
              'vc.story.s5.sec1PeerB1',
              'vc.story.s5.sec1PeerB2',
              'vc.story.s5.sec1PeerB3',
            ],
          },
        ],
      },
      {
        titleKey: 'vc.story.s5.sec2Title',
        bodyKey: 'vc.story.s5.sec2Body',
        bulletKeys: ['vc.story.s5.sec2B1', 'vc.story.s5.sec2B2', 'vc.story.s5.sec2B3'],
      },
      {
        titleKey: 'vc.story.s5.sec3Title',
        bulletKeys: ['vc.story.s5.sec3B1', 'vc.story.s5.sec3B2', 'vc.story.s5.sec3B3'],
      },
    ],
  },
  s6: {
    leadKey: 'vc.story.s6.p1',
    sections: [
      {
        titleKey: 'vc.story.s6.secTipsTitle',
        bulletKeys: ['vc.story.s6.p2', 'vc.story.s6.p3', 'vc.story.s6.p4', 'vc.story.s6.p5'],
      },
    ],
  },
}

export function getGuideStoryLayout(storyId: GuideStoryId): GuideStoryLayout | null {
  return GUIDE_STORY_LAYOUTS[storyId] ?? null
}
